import "./app.css";
import { useAuth } from "@workos-inc/authkit-react";
import { getAdminPermissions } from "@/shared/config/adminPermissions";
import { EntryViewStateProvider } from "@/shared/contexts/EntryViewStateContext";
import { ThemeProvider } from "@/shared/hooks/useTheme";
import { Toaster } from "./components/ui/toaster";
import { V2Routes } from "./routes";

export function V2App() {
	const { user } = useAuth();
	const { isAdmin, canView } = getAdminPermissions(user?.email);

	return (
		<EntryViewStateProvider key={user?.id}>
			<ThemeProvider>
				<Toaster />
				<V2Routes
					isAdmin={isAdmin}
					canViewBilling={canView.billing}
					canManageMatters={canView.matters}
					isMatterOnlyAdmin={
						canView.matters &&
						!canView.overview &&
						!canView.billing &&
						!canView.entries &&
						!canView.calendar &&
						!canView.support
					}
				/>
			</ThemeProvider>
		</EntryViewStateProvider>
	);
}
